import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import NewReleases from "./components/NewReleases";
import Showcase from "./components/Showcase";
import FAQ from "./components/FAQ";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollTop from "./components/ScrollTop";
import SeoJsonLd from "./components/SeoJsonLd";

export default function Home() {
  const [genre, setGenre] = useState("全部");
  const [search, setSearch] = useState("");

  const selectGenre = (g: string) => {
    setGenre(g);
    setSearch("");
    document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main className="bg-background-50">
      <SeoJsonLd />
      <Navbar />
      <Hero onSearch={setSearch} />
      <Ranking />
      <Featured genre={genre} setGenre={setGenre} search={search} />
      <Categories onSelect={selectGenre} />
      <NewReleases />
      <Showcase />
      <FAQ />
      <About />
      <Contact />
      <Footer />
      <ScrollTop />
    </main>
  );
}